import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import { localsMessages } from '../utility/getTemplateData'
import { getCountryInfo } from '../utility/localizer'
import { setCountryAndLocale } from '../utility/helper'

const messages = localsMessages('common/guestTerms')

const styles = StyleSheet.create({
	wrapper: {
		marginTop: 15,
		position: 'relative',
		borderTop: '1px solid rgba(0, 0, 0, 0.2)',
		paddingTop: 15,
	},
	checkboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline',
	},
	checkbox: {
		':before': {
			overflow: 'hidden',
		}
	},
	checkboxWithErr: {
		':before': {
			border: '1px solid #d20000',
		}
	},
	checkText: {
		fontSize: '15px',
		lineHeight: '20px',
		marginLeft: '40px',
		fontFamily: 'pp-sans-small-regular',
	},
	termsText: {
		fontFamily: 'pp-sans-small-regular',
		fontSize: 15,
	},
	checkText2: {
		margin: '20px auto',
		fontFamily: 'pp-sans-big-regular',
	},
	checkError: {
		fontSize: 13,
		color: '#D20000',
		marginLeft: 40,
	},
	legalBlurb: {
		lineHeight: '18px',
		marginLeft: '40px',
		fontFamily: 'pp-sans-big-regular',
	}
})


class GuestTerms extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isChecked: !!this.props.isChecked
		};
	}

	createMarkup = () => {
		return { __html: setCountryAndLocale(messages.terms) };
	}


	onChange = (event) => {
		const isChecked = event.target.checked
		this.setState({ isChecked })
		this.props.handleRequired(isChecked);
	}

	render () {
		const countryInfo = getCountryInfo(this.props.country);
		const checkboxClassName = {
			[css(styles.checkbox)]: true,
			[css(styles.checkboxWithErr)]: this.props.hasError,
		}

		return (
			<div>
				{countryInfo.showGuestTermsCheckBox && !this.props.mandatory && !this.props.isSignUp &&
				<div className={css(styles.wrapper)}>
					<div className={`vx_checkbox ${css(styles.checkboxWrapper)}`}>
						<input
							className={css(styles.inputClassNames)}
							name="termsCheckbox"
							id="termsCheckbox"
							type="checkbox"
							checked={this.state.isChecked}
							onChange={this.onChange} />
						<label htmlFor="termsCheckbox" className={classNames(checkboxClassName)}>
							<span className="sr-only">{this.props.label}</span>
						</label>
					</div>
					<p className={`vx_text-legal ${css(styles.legalBlurb)}`} dangerouslySetInnerHTML={this.createMarkup()}></p>
					{this.props.hasError && <p className={css(styles.checkError)}>
						<span className="icon icon-small icon-critical-small" aria-hidden="true" ></span>
						<span>{messages.pleaseConfirm}</span>
					</p>}
				</div>}

				{countryInfo.showGuestTermsText && !this.props.mandatory && <div
					className={`vx_text-legal text-center ${css(styles.checkText2)}`}
					dangerouslySetInnerHTML={this.createMarkup()}>
				</div>}
			</div>
		);
	}
}

GuestTerms.propTypes = {
	handleRequired: PropTypes.func,
	label: PropTypes.string,
	country: PropTypes.string,
	isSignUp: PropTypes.bool,
	mandatory: PropTypes.bool,
	isChecked: PropTypes.bool,
	hasError: PropTypes.bool,
};

export default GuestTerms



// WEBPACK FOOTER //
// ./components/guestTerms.js